<template>
  <div class="res-topology-toolbar">
    <a-tooltip v-for="item in menus" :key="item.icon" placement="top">
      <template slot="title">
        <span>{{ item.title }}</span>
      </template>
      <a-button type="link" :class="{'toolbar-btn': true, 'ml-2': item.icon !== 'double-right'}" :icon="item.icon" @click="menuClick(item)" />
    </a-tooltip>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menus: [
        { icon: 'double-right', type: 'expand', title: this.$t('system.expand_child_node') },
        { icon: 'double-left', type: 'fold', title: this.$t('system.fold_child_node') },
        { icon: 'zoom-out', type: 'zoomOut', title: this.$t('system.zoom_out') },
        { icon: 'zoom-in', type: 'zoomIn', title: this.$t('system.zoom_in') },
      ],
    }
  },
  methods: {
    menuClick (data) {
      this.$emit('click', data.type)
    },
  },
}
</script>

<style lang="less" scoped>
.res-topology-toolbar {
  position: absolute;
  right: 0;
  top: 0;
  .toolbar-btn {
    background: #fff;
    border-radius: 50%;
  }
}
</style>
